import React from 'react';
import '../Services.css';
import Image1 from '../../Gemco-Website-Images/Services/Commercial_Kitchen_MEP.jpg';

const Service_seven = () => {
  return (
    <div className='wp_sub_service'>
      <div className="container wp_sub_service_container">
          <div className="row wp_service_row">
            <div className="content-column">
              <div className="inner-column wp_service_inner_column">
                <div className='sec-title forseotitle wp_service_sec_title'>
                  <h1>Specialist Civil Works</h1>
                  <p>A unique capability that differentiates GEMCO — specialist interior civil works delivered 
                      alongside MEP for a single-contract solution on prestige projects.</p>
                  <ul>
                  <li className="service_list_item">Terrazzo flooring supply and installation — all patterns and finishes</li>
                  <li className="service_list_item">Special stone and marble flooring works</li>
                  <li className="service_list_item">Acoustic coating and specialist paint application</li>
                  <li className="service_list_item">Core cutting and concrete works</li>
                  <li className="service_list_item">Wall and floor chasing for MEP routes</li>
                  <li className="service_list_item">Reinstatement works to original finish standard</li>
                </ul>
                </div>
              </div>
            </div>
            <div className="image-column">
              <img src={Image1} width="500" height="400" alt="" />
            </div>
          </div>
      </div>
    </div>
  )
}

export default Service_seven